<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.name" [term]="t" class="text-wrap"></ngb-highlight>
</ng-template>

<div class="container h-100">
  <!-- mobile view -->
  <div class="row row-cols-1">
    <div class="col">
      <h5>Bitte erfassen Sie zuerst Ihre persönlichen Daten</h5>

      <form (ngSubmit)="checkReady()" [formGroup]="baseDataForm" class="p-3">
        <div class="input-group">
          <label class="small w-100" title="Ihr Vorname; erforderlich">
            Vorname*
          </label>
          <input
            aria-label="Vorname"
            autocomplete="vorname"
            class="form-control"
            formControlName="vorname"
            placeholder="Vorname"
            tabindex="2"
            type="text"
          />
        </div>
        <san-form-input-error
          [visible]="
            !baseDataForm.controls.vorname.pristine &&
            baseDataForm.controls.vorname.errors &&
            baseDataForm.controls.vorname.errors.required
          "
          message="Bitte geben Sie Ihren Vornamen an"
        ></san-form-input-error>

        <div class="input-group mt-3">
          <label class="small w-100" title="Ihr Nachname; erforderlich">
            Nachname*
          </label>
          <input
            aria-label="Nachname"
            autocomplete="nachname"
            class="form-control"
            formControlName="nachname"
            placeholder="Nachname"
            tabindex="3"
            type="text"
          />
        </div>
        <san-form-input-error
          [visible]="
            !baseDataForm.controls.nachname.pristine &&
            baseDataForm.controls.nachname.errors &&
            baseDataForm.controls.nachname.errors.required
          "
          message="Bitte geben Sie Ihren Nachnamen an"
        ></san-form-input-error>

        <div class="input-group mt-3">
          <label class="small w-100" title="Ihr Geschlecht; erforderlich">
            Geschlecht*
          </label>
          <select
            aria-label="Geschlecht"
            autocomplete="geschlecht"
            class="form-select"
            formControlName="geschlecht"
            tabindex="4"
          >
            <option [value]="null" selected>Geschlecht wählen</option>
            <!-- 1 weiblich, 2 männlich, 3 unbekannt, 4 divers -->
            <option [value]="1">Weiblich</option>
            <option [value]="2">Männlich</option>
            <option [value]="4">Divers</option>
          </select>
        </div>
        <san-form-input-error
          [visible]="
            !baseDataForm.controls.geschlecht.pristine &&
            baseDataForm.controls.geschlecht.errors &&
            baseDataForm.controls.geschlecht.errors.required
          "
          message="Bitte geben Sie Ihr Geschlecht an"
        ></san-form-input-error>

        <div class="input-group mt-3">
          <label class="small w-100" title="Ihr Geburtstag; erforderlich">
            Geburtstag*
          </label>
          <div class="input-group">
            <input
              #geburtsdarumDp="ngbDatepicker"
              [maxDate]="today"
              [minDate]="{ year: 1900, month: 1, day: 1 }"
              aria-label="Geburtstag"
              autocomplete="geburtstag"
              class="form-control fake-input"
              formControlName="geburtsdatum"
              ngbDatepicker
              placeholder="TT.MM.JJJJ"
              tabindex="5"
            />
            <input
              (focusout)="setValueFromMaskedDate(true)"
              [(ngModel)]="maskDateInput"
              (ngModelChange)="setValueFromMaskedDate()"
              [dropSpecialCharacters]="false"
              [ngModelOptions]="{ standalone: true }"
              aria-label="Geburtstag"
              autocomplete="geburtstag"
              class="form-control"
              mask="d0.M0.0000"
              placeholder="TT.MM.JJJJ"
              tabindex="5"
              type="text"
            />
            <span
              (click)="geburtsdarumDp.toggle()"
              class="btn btn-outline-info"
            >
              <fa-icon [icon]="calendarIcon"></fa-icon>
            </span>
          </div>
          <san-form-input-error
            [visible]="
              !baseDataForm.controls.geburtsdatum.pristine &&
              baseDataForm.controls.geburtsdatum.errors &&
              baseDataForm.controls.geburtsdatum.errors.ngbDate
            "
            message="Kein gültiges Datum. Bitte in Format 'tt.mm.jjjj' angeben"
          ></san-form-input-error>
        </div>
        <san-form-input-error
          [visible]="
            !baseDataForm.controls.geburtsdatum.pristine &&
            baseDataForm.controls.geburtsdatum.errors &&
            baseDataForm.controls.geburtsdatum.errors.required
          "
          message="Bitte geben Sie Ihren Geburtstag an"
        ></san-form-input-error>
        <san-form-input-error
          [visible]="
            !baseDataForm.controls.geburtsdatum.pristine &&
            baseDataForm.controls.geburtsdatum.errors &&
            baseDataForm.controls.geburtsdatum.errors.noFutureDate
          "
          message="Das Datum darf nicht in der Zukunft liegen"
        ></san-form-input-error>
      </form>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col text-center">
      <button (click)="zurueck.emit()" class="btn btn-primary m-lg-5">
        Zurück
      </button>
    </div>
    <div class="col text-center">
      <button (click)="checkReady()" class="btn btn-primary m-lg-5">
        Weiter
      </button>
    </div>
  </div>
</div>
